var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shadow/matic2",
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9839 28.3319C41.4708 28.0275 40.8039 28.0275 40.2395 28.3319L36.2377 30.666L33.5185 32.1882L29.5167 34.5222C29.0036 34.8266 28.3367 34.8266 27.7723 34.5222L24.5914 32.6956C24.0783 32.3911 23.7192 31.833 23.7192 31.2241V27.6216C23.7192 27.0127 24.027 26.4545 24.5914 26.1501L27.721 24.3742C28.234 24.0698 28.901 24.0698 29.4654 24.3742L32.595 26.1501C33.1081 26.4545 33.4672 27.0127 33.4672 27.6216V29.9556L36.1864 28.3827V26.0486C36.1864 25.4397 35.8786 24.8816 35.3142 24.5772L29.5167 21.2283C29.0036 20.9239 28.3367 20.9239 27.7723 21.2283L21.8722 24.5772C21.3078 24.8816 21 25.4397 21 26.0486V32.797C21 33.4059 21.3078 33.9641 21.8722 34.2685L27.7723 37.6174C28.2854 37.9218 28.9523 37.9218 29.5167 37.6174L33.5185 35.334L36.2377 33.7611L40.2395 31.4778C40.7525 31.1734 41.4195 31.1734 41.9839 31.4778L45.1135 33.2537C45.6265 33.5582 45.9857 34.1163 45.9857 34.7252V38.3277C45.9857 38.9366 45.6779 39.4947 45.1135 39.7992L41.9839 41.6258C41.4708 41.9302 40.8039 41.9302 40.2395 41.6258L37.1099 39.8499C36.5968 39.5455 36.2377 38.9873 36.2377 38.3784V36.0444L33.5185 37.6174V39.9514C33.5185 40.5603 33.8263 41.1184 34.3907 41.4228L40.2908 44.7717C40.8039 45.0761 41.4708 45.0761 42.0352 44.7717L47.9353 41.4228C48.4484 41.1184 48.8075 40.5603 48.8075 39.9514V33.203C48.8075 32.5941 48.4997 32.036 47.9353 31.7315L41.9839 28.3319Z",
    fill: "#DBC9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9839 28.3319C41.4708 28.0275 40.8039 28.0275 40.2395 28.3319L36.2377 30.666L33.5185 32.1882L29.5167 34.5222C29.0036 34.8266 28.3367 34.8266 27.7723 34.5222L24.5914 32.6956C24.0783 32.3911 23.7192 31.833 23.7192 31.2241V27.6216C23.7192 27.0127 24.027 26.4545 24.5914 26.1501L27.721 24.3742C28.234 24.0698 28.901 24.0698 29.4654 24.3742L32.595 26.1501C33.1081 26.4545 33.4672 27.0127 33.4672 27.6216V29.9556L36.1864 28.3827V26.0486C36.1864 25.4397 35.8786 24.8816 35.3142 24.5772L29.5167 21.2283C29.0036 20.9239 28.3367 20.9239 27.7723 21.2283L21.8722 24.5772C21.3078 24.8816 21 25.4397 21 26.0486V32.797C21 33.4059 21.3078 33.9641 21.8722 34.2685L27.7723 37.6174C28.2854 37.9218 28.9523 37.9218 29.5167 37.6174L33.5185 35.334L36.2377 33.7611L40.2395 31.4778C40.7525 31.1734 41.4195 31.1734 41.9839 31.4778L45.1135 33.2537C45.6265 33.5582 45.9857 34.1163 45.9857 34.7252V38.3277C45.9857 38.9366 45.6779 39.4947 45.1135 39.7992L41.9839 41.6258C41.4708 41.9302 40.8039 41.9302 40.2395 41.6258L37.1099 39.8499C36.5968 39.5455 36.2377 38.9873 36.2377 38.3784V36.0444L33.5185 37.6174V39.9514C33.5185 40.5603 33.8263 41.1184 34.3907 41.4228L40.2908 44.7717C40.8039 45.0761 41.4708 45.0761 42.0352 44.7717L47.9353 41.4228C48.4484 41.1184 48.8075 40.5603 48.8075 39.9514V33.203C48.8075 32.5941 48.4997 32.036 47.9353 31.7315L41.9839 28.3319Z",
    stroke: "#8247E5",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0.49995,
    y: 0.500011,
    width: 68.8075,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290483 0 0 0 0 0.0920513 0 0 0 0 0.623444 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.736941 0 0 0 0 0.278432 0 0 0 0 0.898039 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.5f73ab3eaaf6f8e9e44edba4bd3fd976.svg";
export { ForwardRef as ReactComponent };